module.exports = __webpack_public_path__ + "img/studiopro_small.dc00c7a5.png";